var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Flex } from 'rebass';
var initials = function (text) {
    if (!text)
        return null;
    return text
        .split(' ')
        .slice(0, 2)
        .map(function (w) { return w.slice(0, 1).toUpperCase(); })
        .join('');
};
export default function Avatar(_a) {
    var sx = _a.sx, _b = _a.variant, variant = _b === void 0 ? 'medium' : _b, children = _a.children, username = _a.username, props = __rest(_a, ["sx", "variant", "children", "username"]);
    return (React.createElement(Flex, __assign({ variant: "avatar." + variant, justifyContent: "center", alignItems: "center", fontSize: 4, color: "neutral_0", bg: "cyan_2" }, props, { sx: __assign({ textAlign: 'center', borderRadius: '50%', lineHeight: '1em' }, (sx ? sx : {})) }), children || initials(username) || null));
}
